var SearchAPI = require('../../common/api/search');

module.exports = function SearchController(
	$scope,
	$state,
	$rootScope,
	$location
) {
	var vm = this;
	vm.searching = false;
	vm.numberOfPages = 0;
	vm.searchOnLoad = false;
	vm.query = {
		text: '',
		sort: 'MostRecentDonationDecreasing',
		simple: true,
		type: ''
	};

	vm.init = function() {
		var previous = $location.search();
		vm.searchOnLoad = previous.searchOnLoad || false;
		vm.pageSize = previous.pageSize || 6;
		vm.pageNumber = previous.pageNumber || 1;
		vm.type = previous.type || '';

		vm.advancedSearching = false;
		if (previous.simple) {
			vm.query = previous;
			if (previous.type === 'Project')
				vm.query.sort = 'MostRecentDonationDecreasing';
		}
		vm.query.searchOnLoad = vm.searchOnLoad;
		vm.query.type = vm.type;
		vm.search();
		return;
	};

	vm.searchChanged = function() {
		vm.pageNumber = 1;
		vm.search();
	};

	function searchCallback(result) {
		vm.results = result.results;
		vm.totalResults = result.totalResults;
		vm.numberOfPages = Math.ceil(vm.totalResults / vm.pageSize);
		vm.results.forEach(function(item) {
			if (
				item.type == 'Funder' ||
				item.type == 'Scheme' ||
				item.type == 'Fundraiser'
			) {
				if (item.pictureId) {
					item.pictureUrl = encodeURI(
						window.conf.doc_repos_url +
							'get/' +
							encodeURIComponent(item.pictureId) +
							'/' +
							item.pictureFileName
					);
				}
			}
		}, this);
	}

	vm.search = function() {
		vm.applications = [];
		vm.searching = true;
		var query = angular.copy(vm.query);
		query.pageNumber = vm.pageNumber;
		query.pageSize = vm.pageSize;
		$location.search(query);
		if (query.text == '' || query.text == null) {
			if (query.searchOnLoad) {
				query.text = '*';
			} else {
				vm.searching = false;
				return;
			}
		}
		SearchAPI.GetAdvancedGlobalSearch(
			query.text,
			query.type,
			query.sort,
			query.pageSize,
			query.pageNumber
		)
			.then(searchCallback)
			.finally(function() {
				vm.searching = false;
			});
	};

	vm.pageChange = function(next, prev) {
		vm.pageNumber = next;
		vm.search();
	};

	vm.getHref = function(result) {
		if (result.type == 'Funder') {
			return '/funders/' + result.publicUrl;
		} else if (result.type == 'Scheme') {
			return '/funders/' + result.publicUrl;
		} else if (result.type == 'Project') {
			return '/project/' + result.publicUrl;
		} else if (result.type == 'Applicant') {
			return '/applicants/' + result.publicUrl;
		} else if (result.type == 'Fundraiser') {
			return '/fundraiser/' + result.publicUrl;
		}
	};

	vm.init();
};
